import './cartpage.css'
import { Link } from 'react-router-dom'
import Cartlist from '../components/Cartlist'
import { useGlobalContext } from '../context'


const Cart = () => {
    const { productcart,itemPrice, clearcart } = useGlobalContext()
    return (
        <div>
            <div className='home-span-container'>
                <h1 className='home-span'> <Link to='/'> Home </Link> <span>/ Cart </span></h1>
            </div>
            <div className='section-container'>
                <Cartlist />
                {
                    productcart.length !== 0 &&(
                        <div className='total-amount'>
                    <h3 className='total-total'>Total</h3>
                    <h2 className='total-amount-amount'>${(itemPrice).toFixed(2)}</h2>   
                    </div>
                    )
                }
            <div className='continue-shopping'>
                <div>
                    <button className='contine-shopping'>Check Out</button>
                    <button className='clear-shopping' onClick={clearcart}>Clear Cart</button>
                </div>
            </div>
            </div>            
        </div>
    )
}

export default Cart
